import getPagesArray from 'legacyfrontend/utils/get-pages-array';
import { useFilters } from '../contexts/FiltersContext';
const Pagination = ({ totalPages, contextHook }) => {
  const pages = getPagesArray(totalPages);
  const { filters, handleFilters } = contextHook ? contextHook() : useFilters();

  return (
    <div className='pagination-container'>
      <div
        className={`pagination__btn first ${filters.page.value === 1 ? 'active' : 'inactive'}`}
        onClick={() => {
          handleFilters('page', 1);
        }}
      >
        1
      </div>
      <div className={`pagination__more${filters.page.value > 4 ? ' show' : ''}`}>...</div>
      {totalPages > 1 && (
        <>
          {pages.map((page) => {
            if (page > filters.page.value - 3 && page < filters.page.value + 3) {
              return (
                <div
                  className={`pagination__btn ${
                    filters.page.value === page ? 'active' : 'inactive'
                  }`}
                  key={page}
                  onClick={() => {
                    handleFilters('page', page);
                  }}
                >
                  {page}
                </div>
              );
            }
          })}
        </>
      )}
      {totalPages > 1 && (
        <>
          <div
            className={`pagination__more${
              filters.page.value < totalPages - 3 && totalPages > 4 ? ' show' : ''
            }`}
          >
            ...
          </div>
          <div
            className={`pagination__btn last ${
              filters.page.value === totalPages ? 'active' : 'inactive'
            }`}
            onClick={() => {
              handleFilters('page', totalPages);
            }}
          >
            {totalPages}
          </div>
        </>
      )}
    </div>
  );
};

export default Pagination;
